import React from 'react'

import { Text } from '@domain-group/suit-theme'

interface SubtitleProps {
  children: React.ReactNode,
}

const Subtitle = (props: SubtitleProps) => {
  const { children } = props

  return (
    <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="medium">
      {children}
    </Text>
  )
}

export default Subtitle
